<template>
  <div class="users">
    <div class="row justify-content-md-center" style="margin-top:10px;">
      <div class="col-lg-6 col-12">
        <b-modal id="editUser" :title="'Edition '+editUser.displayName" scrollable 
          header-bg-variant="light"
          header-text-variant="dark"
          body-bg-variant="light"
          body-text-variant="dark"
          footer-bg-variant="light"
          footer-text-variant="dark"
          ok-title="Enregistrer"
          cancel-title="Annuler"
          @ok="save"
        >
          <div class="row">
            <div class="col-lg-6 col-12">
              <b-alert variant="danger" show v-if="error">{{ error }}</b-alert>
              <b-form @submit="save">
                <b-form-group id="input-group-date" label="Fin de validité:" label-for="input-date" v-if="expires_at">
                  <b-form-input
                    id="input-date"
                    v-model="expires_at"
                    type="date"
                    :min="expires_at"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-checkbox
                  id="input-admin"
                  v-model="editUser.customClaims.admin"
                  :value="true"
                  :unchecked-value="false"
                >
                  Administrateur
                </b-form-checkbox>
              </b-form>
            </div>
          </div>
        </b-modal>
        <table class="table table-striped table-hover table-dark text-center">
          <thead class="thead-dark">
            <tr><th scope="col" class="text-left">Nom</th><th scope="col">Abonné</th><th scope="col">Validité</th><th scope="col" class="d-none d-md-table-cell">Accès</th><th scope="col" class="d-none d-md-table-cell">Identifiant</th></tr>
          </thead>
          <tbody>
            <tr v-for="user in users" v-bind:key="user.id" v-on:click="edit(user)" class="button">
              <td class="text-left">{{ user.displayName }}</td>
              <td>
                <b-badge variant="success" v-if="user.customClaims && user.customClaims.subscription && user.customClaims.subscription.active">OUI</b-badge>
                <b-badge variant="danger" v-else >NON</b-badge>
              </td>
              <td :class="(user.customClaims && user.customClaims.subscription && user.customClaims.subscription.expires_at > moment().unix()) ? 'text-success' : 'text-danger'">
                {{ user.customClaims && user.customClaims.subscription && user.customClaims.subscription.expires_at ?
                moment(user.customClaims.subscription.expires_at).format('DD/MM/YYYY') :
                '-' }}
              </td>
              <td class="d-none d-md-table-cell">
                <b-badge variant="warning" style="margin-right: 2px;" v-if="user.customClaims && user.customClaims.admin">ADMIN</b-badge>
              </td>
              <td class="d-none d-md-table-cell"><small>{{ user.uid }}</small></td>
            </tr>
          </tbody>
        </table>
      </div>      
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase.js'
import moment from 'moment'

const getUsers = firebase.functions().httpsCallable('users')
const setUserClaims = firebase.functions().httpsCallable('setUserClaims')

export default {
  data: () => ({
    users: [],
    editUser: { customClaims: { admin: false }},
    expires_at: null,
    error: null
  }),
  methods: {
    moment(ts) { return ts ? moment.unix(ts) : moment() },
    edit(user) {
      this.editUser = user
      if(user.customClaims && user.customClaims.subscription && user.customClaims.subscription.expires_at) {
        this.expires_at = moment.unix(user.customClaims.subscription.expires_at).format('YYYY-MM-DD')
      } else {
        this.editUser.customClaims = this.editUser.customClaims || {}
        if(confirm("Activer l'accès VIP de cet utilisateur ?")) {
          this.editUser.customClaims.subscription = { active: false, expires_at: 0 }
          this.expires_at = moment().format('YYYY-MM-DD')
        } else {
          this.expires_at = null
        }
      }
      this.$bvModal.show("editUser")
    },
    save() {
      setUserClaims({ uid: this.editUser.uid, customClaims: this.editUser.customClaims })
    }
  },
  created() {
    getUsers().then((result) => {
      result.data.users.forEach((user) => this.users.push(user))
    })
  },
  watch: {
    immediate: true,
    expires_at: function(value) {
      if(value) {
        this.editUser.customClaims.subscription.expires_at = moment.utc(value).unix()
      }
    }
  }
}
</script>